import { render } from "./UserCircleGear.vue?vue&type=template&id=2367a438"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/UserCircleGear.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2367a438"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2367a438', __exports__)) {
    api.reload('2367a438', __exports__)
  }
  
  module.hot.accept("./UserCircleGear.vue?vue&type=template&id=2367a438", () => {
    api.rerender('2367a438', render)
  })

}


export default __exports__